import { useEffect, useState } from 'react'

import { useFormikContext } from 'formik'
import { WriterFormType } from '@models/writer/WriterFormType'
import { useDebounce } from '@hooks/useDebounce'
import { useWriterAction } from '@hooks/writer/useWriterAction'
import { WriterEnum } from '@interfaces/WriterEnum'
import { useAuthentication } from '@hooks/useAuthentication'
import { WriterInformationProps } from './interface'

export function withWriterInformation(
  Component: React.FC<WriterInformationProps>
) {
  function WithWriterInformation() {
    const writerClient = useWriterAction()
    const { user } = useAuthentication()
    const { debounce } = useDebounce()
    const { values, setFieldValue } = useFormikContext<WriterFormType>()
    const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false)

    useEffect(() => {
      debounce(() => {
        let verifyId

        if (values.type === WriterEnum.INDIVIDUAL) {
          verifyId = values?.idNumber
        } else {
          verifyId = values?.taxId
        }

        if (verifyId.length === 13 && !user.writerRequest?.writer) {
          writerClient.verifyNumberHasBan(verifyId).then(res => {
            setFieldValue(
              values.type === WriterEnum.INDIVIDUAL
                ? 'validateNumberId'
                : 'validateTaxId',
              !res
            )
            if (res) {
              setShowErrorMessage(res)
            }
          })
        } else if (user.writerRequest?.writer) {
          setFieldValue(
            values.type === WriterEnum.INDIVIDUAL
              ? 'validateNumberId'
              : 'validateTaxId',
            true
          )
        }
      }, 400)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.type, values.idNumber, values.taxId])

    useEffect(() => {
      if (showErrorMessage) {
        setShowErrorMessage(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.idNumber, values.taxId, values.type])

    const componentProps = {
      values,
      showErrorMessage,
    }

    return <Component {...componentProps} />
  }

  return WithWriterInformation
}
